import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14 5a1 1 0 0 0-1-1H6l-.15.005A2 2 0 0 0 4 6v20l.005.15A2 2 0 0 0 6 28h7l.117-.007A1 1 0 0 0 13 26H6V6h7l.117-.007A1 1 0 0 0 14 5m8.459 5.043-.095-.083a1 1 0 0 0-1.32.083l-.083.094a1 1 0 0 0 .083 1.32L24.585 15H13l-.117.007A1 1 0 0 0 13 17h11.585l-3.54 3.543-.084.094a1 1 0 0 0 1.498 1.32l5.248-5.25.083-.094a1 1 0 0 0-.083-1.32z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconSignOut = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconSignOut);
export default Memo;
